<template>
    <div v-if="items.length === 0" class="text-muted">
        Nenhum produto
    </div>

    <el-card
        v-for="(item, index) in items"
        :key="index"
        class="product-item mb-1 p-2"
        body-class="no-padding"
        :body-style="{padding: '0px !important'}"
        shadow="hover"
    >
        <ElRow align="middle" items="center" justify="space-between">
            <div>
                <ElRow align="middle" items="center">

                    <!-- AVATAR -->
                    <el-avatar
                        :size="48"
                        :src="item.image ?? undefined"
                        class="me-3"
                    >
                        {{ item.title.charAt(0) }}
                    </el-avatar>
            
                    <!-- CONTENT -->
                    <div class="product-content">
                        <div class="product-title">
                            {{ item.title }}
                        </div>
            
                        <div class="product-subtitle">
                            {{ item.subtitle }}
                        </div>
                    </div>
                </ElRow>
            </div>

            <div>
                <!-- ACTION -->
                <el-button
                    type="primary"
                    circle
                    class="ml-auto"
                    @click="clickOpen(item.id)"
                >
                    <el-icon>
                        <View />
                    </el-icon>
                </el-button>
                <template>
                    <span class="p-2" v-if="!item.featured">
                        <el-button :loading="item.loading" @click="() => featured(item)" type="success" title="Destacar" icon="Upload"></el-button>
                    </span>
                    <span class="p-2" v-else>
                        <el-button :loading="item.loading" @click="() => featured(item)" type="warning" title="Despromover" icon="Download"></el-button>
                    </span>
                </template>
            </div>
        </ElRow>
    </el-card>
</template>

<script setup lang="ts">
import Api from '@/services/api';
import { Upload } from '@element-plus/icons-vue/dist/types';
import { ElMessage, ElRow } from 'element-plus';

    const props = defineProps<{
        items: {
            image: string
            title: string
            subtitle: string
            icon: string
            id: number | string
            featured: boolean 
            loading: boolean 
        }[]
    }>()

    const emit = defineEmits<{clickOpen: [id: number | string]}>()
    const clickOpen = (id: number | string) => {
        emit('clickOpen', id)
    }

    const featured = async (row: any) => {
        row.loading = true
        const res = await Api.put(`admin/featured/product/${row.id}`, {})
        if (res.status != 200) {
            ElMessage.error({message: 'Ocorreu um erro ' + res.data.message ? res.data.message:''})
        } else {
            ElMessage.success({message: row.title + ' Actualizado com sucesso'})
            row.featured = !row.featured
        }
        row.loading = false
    }
</script>

<style lang="css" scoped>
    .product-item {
        border-radius: 12px;
    }

    .product-title {
        font-weight: 600;
        font-size: 1rem;
    }

    .product-subtitle {
        font-size: 0.9rem;
    }

    .el-card__body {
        padding: 0px !important;
    }

</style>